 /* istanbul ignore file */
import { connect } from 'react-redux';
import EmbedCodeView from './EmbedCodeView';

const mapStateToProps = (state, ownProps) => {
    const { issueConfig } = state.issueConfig;
    
    return {
        issueConfig,
        store: ownProps.store
    };
}

const mapDispatchToProps = () => {
    return {
    
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmbedCodeView);